import styled, { x } from '@xstyled/styled-components';
import React, { ButtonHTMLAttributes, FC } from 'react';
import { t } from 'ttag';
import Icon from '~/assets/icons/rewind.svg';

const Button = styled.button`
  background: ${p => p.theme.colors.overlayMed};
  width: 45px;
  height: 45px;
  border-radius: 30px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: relative;
  padding: 0;
  &:focus {
    outline: 2px solid blue;
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 25px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 25px;
    height: 25px;
    padding: 4.5px;
    div {
      font-size: 8px;
    }
  }
`;

const StyledIcon = styled(Icon)<{
  title?: string;
}>`
  width: 30px;
  height: 30px;
  transform: scale(2);
`;

export const ReplayButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => (
  <Button aria-label={t`Replay`} {...props} style={{ zIndex: 100 }}>
    <StyledIcon title={`Replay`} />
    <x.div
      position="absolute"
      fontSize="14"
      fontWeight="bold"
      lineHeight="15px"
    >
      {children}
    </x.div>
  </Button>
);
